/* NS Product — ficha de producto propia. Sustituye a ns-pre-product.js y al JS de
   variantes de XTRA. Variante: re-pinta la sección con ?variant=ID (Section Rendering
   API) y cambia solo los trozos que dependen de la variante. */
(function () {
  'use strict';
  var root = document.querySelector('.ns-pdp');
  if (!root) return;
  var sid = root.dataset.sectionId;
  var jsonEl = document.querySelector('[data-ns-product-json]');
  var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) return Shopify.formatMoney(cents, Shopify.money_format);
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: cur }).format(cents / 100);
  }

  /* Galería */
  function showMedia(id) {
    $$('.ns-pg-slide').forEach(function (s) { s.hidden = String(s.dataset.mediaId) !== String(id); });
    $$('.ns-pg-thumb').forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.nsThumb) === String(id)); });
  }
  var first = $('.ns-pg-slide:not([hidden])');
  if (first) showMedia(first.dataset.mediaId);
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-ns-thumb]');
    if (th) showMedia(th.dataset.nsThumb);
    var z = e.target.closest('[data-ns-zoom]');
    var dlg = $('[data-ns-zoom-dialog]');
    if (z && dlg && dlg.showModal) { $('img', dlg).src = z.dataset.full; dlg.showModal(); }
    if (e.target.closest('[data-ns-zoom-close]') || e.target === dlg) dlg && dlg.close();
  });

  /* Variantes */
  function currentVariantId() {
    var opts = [];
    $$('input[data-option-index]:checked', root).forEach(function (i) { opts[Number(i.dataset.optionIndex)] = i.value; });
    if (!product || !opts.length) return null;
    var v = product.variants.filter(function (x) { return opts.every(function (o, k) { return x.options[k] === o; }); })[0];
    return v ? v.id : null;
  }
  function swap(variantId) {
    var u = new URL(location.href);
    u.searchParams.set('variant', variantId);
    var shown = u.pathname + u.search;
    u.searchParams.set('section_id', sid);
    fetch(u.pathname + u.search).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.ns-pdp-info');
      var cur = $('.ns-pdp-info');
      if (!fresh || !cur) return;
      var qty = $('[data-ns-pqty]', cur);
      var q = qty ? qty.value : null;
      var open = $$('details', cur).map(function (d) { return d.open; });
      cur.replaceWith(fresh);
      $$('details', fresh).forEach(function (d, i) { d.open = open[i]; });
      var nq = $('[data-ns-pqty]', fresh); if (nq && q) nq.value = q;
      var mid = $('.ns-pg-slide:not([hidden])', doc);
      var v = product.variants.filter(function (x) { return x.id === Number(variantId); })[0];
      if (v && v.featured_media) showMedia(v.featured_media.id);
      var sp = $('[data-ns-sticky-price]'), sb = $('[data-ns-sticky-add]');
      var fb = $('[data-ns-atc]', fresh);
      var np = $('.ns-pdp-price-now', fresh);
      if (sp) sp.textContent = np ? np.textContent : (v ? money(v.price) : sp.textContent);
      if (sb && fb) { sb.disabled = fb.disabled; sb.textContent = fb.textContent.trim(); }
      history.replaceState(null, '', shown);
      watchAtc();
      loadComplementary();
      updatePack();
    });
  }
  root.addEventListener('change', function (e) {
    if (!e.target.matches('input[data-option-index]')) return;
    var id = currentVariantId();
    if (id) swap(id);
  });

  /* Cantidad y packs */
  function qtyInput() { return $('[data-ns-pqty]'); }
  function updatePack() {
    var box = $('[data-ns-pack]');
    if (!box) return;
    var q = qtyInput() ? Number(qtyInput().value) : 1;
    var price = Number(box.dataset.price);
    var pct = q >= 3 ? Number(box.dataset.p3) : q >= 2 ? Number(box.dataset.p2) : 0;
    $$('.ns-pack-btn', box).forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.qty) === q); });
    var save = $('[data-ns-pack-save]', box);
    if (pct > 0) {
      save.hidden = false;
      save.textContent = '✓ ' + q + ' × ' + money(Math.round(price * (100 - pct) / 100)) + ' — −' + pct + '% (' + money(Math.round(price * q * pct / 100)) + ')';
    } else save.hidden = true;
  }
  document.addEventListener('click', function (e) {
    var st = e.target.closest('[data-ns-step]');
    if (st && qtyInput()) {
      qtyInput().value = Math.max(1, Number(qtyInput().value) + Number(st.dataset.nsStep));
      updatePack();
    }
    var pk = e.target.closest('.ns-pack-btn');
    if (pk && qtyInput()) { qtyInput().value = pk.dataset.qty; updatePack(); }
  });
  document.addEventListener('input', function (e) { if (e.target.matches('[data-ns-pqty]')) updatePack(); });
  updatePack();

  /* Barra fija: aparece cuando el botón de compra sale de pantalla */
  var atcObserver = null;
  function watchAtc() {
    var bar = $('[data-ns-sticky]');
    var atc = $('[data-ns-atc]');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    if (atcObserver) atcObserver.disconnect();
    atcObserver = new IntersectionObserver(function (en) {
      var gone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', gone);
      bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
    });
    atcObserver.observe(atc);
  }
  watchAtc();
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ns-sticky-add]')) return;
    var f = $('form.ns-buy');
    if (f && window.NSCart) window.NSCart.add(f);
  });

  /* Complementarios */
  function loadComplementary() {
    var box = $('[data-ns-comp]');
    if (!box || box.children.length) { if (box && box.children.length) box.closest('[data-ns-comp-wrap]').hidden = false; return; }
    fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = $('[data-ns-comp]', doc);
      if (src && src.querySelector('.ns-pcard, li')) {
        box.innerHTML = src.innerHTML;
        box.closest('[data-ns-comp-wrap]').hidden = false;
      }
    }).catch(function () {});
  }
  loadComplementary();
})();
